import { render, staticRenderFns } from "./OrderTransaction.vue?vue&type=template&id=b5d304fe&scoped=true&"
import script from "./OrderTransaction.vue?vue&type=script&lang=js&"
export * from "./OrderTransaction.vue?vue&type=script&lang=js&"
import style0 from "./OrderTransaction.vue?vue&type=style&index=0&id=b5d304fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../boss_taobao/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d304fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../boss_taobao/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VList,VListItem,VListItemAction,VListItemContent,VListItemGroup,VSelect,VTextField,VTextarea,VTooltip})
